import { all, fork, takeLatest, put, call } from 'redux-saga/effects';

import { GET_ORG_PANELS } from '../actions/types';

import { db } from 'config/firebase';

// Loggers
import { log } from 'utils/Loggers';

import { openSnackbar } from 'store/actions/Snackbar';

import {
    getOrgKiosksFailure,
    getOrgKiosksSuccess,
    getOrgPanelsFailure,
    getOrgPanelsSuccess
} from '../actions/Panels';

import { collection, doc, getDoc, getDocs, query, where } from 'firebase/firestore';

// Panels are the org's kiosks in `org.hardware`.
const getOrgKiosksRequest = async ({ orgs }) => {
    const devicesByOrg = {};

    await Promise.all(
        Object.values(orgs).map(async ({ org_id: orgId }) => {
            const orgSnapshot = await getDoc(doc(db, 'orgs', orgId));
            const kiosks = (orgSnapshot.data()?.hardware || []).filter(
                device => device?.type === 'kiosk'
            );

            devicesByOrg[orgId] = kiosks;
        })
    );

    return devicesByOrg;
};

export function* getOrgKiosks(user) {
    const { orgs, active_org_id } = user;

    try {
        const devicesByOrg = yield call(getOrgKiosksRequest, { orgs });

        yield put(getOrgKiosksSuccess(devicesByOrg));
    } catch (error) {
        yield put(getOrgKiosksFailure(error));
        log('Org Devices Error: getting kiosks by user org(s) data', {
            error,
            orgs,
            active_org_id,
            user
        });
    }
}

export function* getOrgPanelUsers({ payload }) {
    const orgId = payload.org_id;
    // const combinedData = [];

    try {
        const usersRef = collection(db, 'users');
        const q = query(
            usersRef,
            where('role', '==', 'panel'),
            where('primary_org', '==', orgId)
        );
        const userSnapshots = yield call(getDocs, q);

        const panelUsers = userSnapshots.docs.map(doc => doc.data());
        const panels = Object.fromEntries(panelUsers.map(user => [user.uid, user]));
        yield put(getOrgPanelsSuccess({ panels, panelUsers }));
    } catch (error) {
        openSnackbar({
            open: true,
            message: `Error fetching panel or user data: ${error}`,
            variant: 'alert',
            alert: {
                color: 'error'
            }
        });
        console.error('Error fetching panel or user data:', error);
        yield put(getOrgPanelsFailure(error.message));
    }
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////// Panel users //////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////// Action Creators For Root Saga ////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export function* getOrgPanelUsersCollections() {
    yield takeLatest(GET_ORG_PANELS, getOrgPanelUsers);
}

export default function* rootSaga() {
    yield all([fork(getOrgPanelUsersCollections)]);
}
